import React, { useEffect, useState } from "react";
import AddScreenTitle from "../components/AddScreenTitle";
import InputText from "../ReusableComponents/InputText";
import TextArea from "../ReusableComponents/TextArea";
import Buttons from "../components/Buttons";
import { mainTable } from "../css/Common";
import MainLayout from "../components/MainLayout";
import GridPage from "../components/GridPage";
import { SourceTypeHeader } from "../components/HeaderAttribute";
import MainPopup from "../popup-containers/MainPopup";
import PopUpButtons from "../components/PopUpButtons";
import PopUpScreenTitle from "../components/PopUpScreenTitle";
import SourceTypePopup from "../popup-containers/SourceTypePopup";
import toast from "react-hot-toast";
import { BindAPI, BindPostAPI, IUDAPI } from "../services/APIConnection";
import Loader from "../ReusableComponents/Loader";
import ErrorPopup from "../ReusableComponents/ErrorPopup";

const SourceType = () => {
  const [visibleAdd, setVisibleAdd] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [visibleTable, setVisibleTable] = useState(true);
  const [addScreenTitle, setAddScreenTitle] = useState(false);
  const [updateScreenTitle, setUpdateScreenTitle] = useState(false);
  const [viewDetails, setViewDetails] = useState(false);
  const [deleteDetails, setDeleteDetails] = useState(false);
  const [blockDetails, setBlockDetails] = useState(false);
  const [unBlockDetails, setUnBlockDetails] = useState(false);
  const [rowIndex, setRowIndex] = useState(null);
  const [popUpData, setPopUpData] = useState(null);
  const [popUpDataDD, setPopUpDataDD] = useState(null);
  const [popUpOpen, setpopUpOpen] = useState(false);
  const [submitBtnDisabled, setSubmitBtnDisabled] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  var createdBy = sessionStorage.getItem("createdBy");
  // const [mstEnquiryLostReasonId, setMstEnquiryLostReasonId] = useState("");
  const [mstSourceTypeId, setMstSourceTypeId] = useState("");
  // const [bindReasonForLostData, setBindReasonForLostData] = useState([]);
  const [bindSourceTypeData, setSourceTypeData] = useState([]);
  var mstClientId = sessionStorage.getItem("MstClientId");

  const [formFields, setFormFields] = useState({
    source: "",
    description: "",
  });

  const [formFieldsError, setFormFieldsError] = useState({
    sourceError: "",
    descriptionError: "",
  });

  const handleView = (rowIndex) => {
    console.log("View clicked", rowIndex);
  };

  const handleDelete = (rowIndex) => {
    console.log("Delete clicked", rowIndex);
  };

  const handleBlock = (rowIndex) => {
    console.log("Block clicked", rowIndex);
  };

  useEffect(() => {
    // bind gird datas
    bindSourceType();
  }, []);

  const bindSourceType = async () => {
    const data={
      mstClientId: 0
    }
    setIsLoading(true); 
    const response = await BindPostAPI(
      data,"SourceTypeAPI/BindSourceType"
    );

    if (response && response.data) {
      setSourceTypeData(response.data.Table);
      setIsLoading(false); 
    } else {
      setSourceTypeData([]);
    }
  };

  const validateForm = () => {
    const errors = {
      sourceError: formFields.source ? "" : "Enter Source type",
      // descriptionError: formFields.description ? "" : "Enter Description",
    };
  
    setFormFieldsError(errors);
  
    return Object.values(errors).every((err) => err === "");
  };

  const handleSubmit = async (rowIndex, flag) => {
            
    setSubmitBtnDisabled(true);
    setIsLoading(true);

    const isValid = validateForm();

    if (flag == 1 || flag == 2) {
      if (!isValid) {
        setIsOpen(true);
        setIsLoading(false);
        setSubmitBtnDisabled(false);
      }
       
      if (isValid) {
        setIsOpen(false);
        setIsLoading(true);
        const data = {
          mstSourceTypeId: mstSourceTypeId ? mstSourceTypeId : 0,
            // mstClientId : mstClientId,
          source: formFields.source,
          description: formFields.description,
          createdBy: createdBy,
          flag: flag,
        };
        const response = await IUDAPI(
          [data],
          "SourceTypeAPI/IUDSourceType"
        );
        if (flag == 1) {
          if (response.data.Table[0].Result === "S") {
            toast.success("Source data inserted successfully! 👍", {
              duration: 3000,
              position: "top-center",
            });
            setTimeout(cancel, 3000);
          } else {
            toast.error("Source data insert failed 👎", {
              duration: 3000,
              position: "top-center",
            });
            setTimeout(cancel, 3000);
          }
        } else if (flag == 2) {
          if (response.data.Table[0].Result === "M") {
            toast.success("Source data modified successfully! 👍", {
              duration: 3000,
              position: "top-center",
            });
            setTimeout(cancel, 3000);
          } else {
            toast.error("Source data modification failed 👎", {
              duration: 3000,
              position: "top-center",
            });
            setTimeout(cancel, 3000);
          }
        }
      } else {
        setSubmitBtnDisabled(false);
      }
    } else {
      const data = {
      mstSourceTypeId: mstSourceTypeId
          ? mstSourceTypeId
          : 0,
        createdBy: parseInt(createdBy) ,
        flag: flag,
      };
      const response = await IUDAPI([data], "SourceTypeAPI/IUDSourceType");

      if (flag == 3) {
        if (response.data.Table[0].Result === "D") {
          toast.success("Source data deleted successfully! 👍", {
            duration: 3000,
            position: "top-center",
          });
          setTimeout(cancel, 3000);
        }
        else if (response.data.Table[0].Result === "ND") {
          toast.success("This Reason is already used. You cannot delete it! 👍", {
            duration: 3000,
            position: "top-center",
          });
          setTimeout(cancel, 3000);
        }
         else {
          toast.error("Failed to delete Source. 👎", {
            duration: 3000,
            position: "top-center",
          });
          setTimeout(cancel, 3000);
        }
      } else if (flag == 4) {
        if (response.data.Table[0].Result === "B") {
          toast.success("Source data Inactivated successfully! 👍", {
            duration: 3000,
            position: "top-center",
          });
          setTimeout(cancel, 3000);
        } else {
          toast.error("Source data Inactivated failed 👎", {
            duration: 3000,
            position: "top-center",
          });
          setTimeout(cancel, 3000);
        }
      } else if (flag == 5) {
        if (response.data.Table[0 ].Result === "UB") {
          toast.success("Source data activated successfully! 👍", {
            duration: 5000,
            position: "top-center",
          });
          setTimeout(cancel, 3000);
        } else {
          toast.error("Source data activated failed! 👎", {
            duration: 3000,
            position: "top-center",
          });
          setTimeout(cancel, 3000);
        }
      }
    }
  };

  const showAdd = () => {
    setVisibleTable(false);
    setAddScreenTitle(true);
    setUpdateScreenTitle(false);
    setVisibleAdd(true);
  };

  const cancel = () => {
    bindSourceType();
    setVisibleTable(true);
    setAddScreenTitle(false);
    setUpdateScreenTitle(false);
    setVisibleAdd(false);
    setIsLoading(false);
    setSubmitBtnDisabled(false);
    // setMstEnquiryLostReasonId("");
    setMstSourceTypeId("");
    setFormFields({
      source: "",
      description: "",
    });
    setFormFieldsError({
      sourceError: "",
      DescriptionError: "",
    });
    setpopUpOpen(false);
  };

  const handleInputChange = (e) => {
        const { name, value } = e.target;
        if(name ==="source"){
          let updatedValue = value.replace(/[^A-Za-z\s]/g, ""); 
          setFormFields((prev) => ({
            ...prev,
            [name]: updatedValue,
          }));
        }
        else{setFormFields((prev) => ({ ...prev, [name]: value })); }
    
  };

  const handleSourceType = (rowIndex, flag) => {

  console.log("handleSourceType triggered", rowIndex, flag);

  setRowIndex(rowIndex);
  setpopUpOpen(true);

  setViewDetails(false);
  setDeleteDetails(false);
  setBlockDetails(false);
  setUnBlockDetails(false);

  if (flag === 1) setViewDetails(true);
  if (flag === 3) setDeleteDetails(true);
  if (flag === 4) setBlockDetails(true);
  if (flag === 5) setUnBlockDetails(true);

  const rowData = bindSourceTypeData[rowIndex];

  setMstSourceTypeId(rowData.MstSourceTypeId);
  setPopUpData(rowData);
  setPopUpDataDD(rowData);
};

  const handleBlur = (e) => {
    const { name } = e.target;
    if (!formFields[name]) {
      setFormFieldsError((prev) => ({
        ...prev,
        [`${name}Error`]: `Enter ${name}`,
      }));
    } else {
      setFormFieldsError((prev) => ({
        ...prev,
        [`${name}Error`]: "",
      }));
    }
  };

  console.log("formFieldsError:", formFieldsError);
  const handleEdit = (rowIndex) => {
    setVisibleAdd(true);
    setVisibleTable(false);
    setAddScreenTitle(false);
    setUpdateScreenTitle(true);
    setMstSourceTypeId(
      bindSourceTypeData[rowIndex].MstSourceTypeId
    );
    setFormFields({
      ...formFields,
      source: bindSourceTypeData[rowIndex].Source,
      description: bindSourceTypeData[rowIndex].Description,
    });
  };

  return (
    <MainLayout pageName={"2"}>
      <Loader
        isVisible={isLoading}
        size="h-20 w-20"
        color="border-t-black"
        blur={true}
      />
      {visibleTable && (
        <GridPage
          header={SourceTypeHeader}
          title={"Source Type"}
          records={bindSourceTypeData}
          handleEdit={handleEdit}
          handleAction={handleSourceType}
          showAdd={showAdd}
          // bindActionDD={true}
        />
      )}

      {visibleAdd && (
        <div className="w-full">
          <div className="flex flex-col w-full">
            <div className={mainTable.clientMasterMainAdd}>
              <AddScreenTitle
                addScreenTitle={addScreenTitle}
                updateScreenTitle={updateScreenTitle}
                title="Source Type"
              />
            </div>
          </div>

          <div class="mx-auto  md:w-[500px] w-full">
            <div class="relative w-full h-full max-w-xl md:h-auto">
              <div class="relative bg-white rounded-lg shadow ">
                <div class="px-6 py-6 lg:px-8">
                  <form>
                    <InputText
                      inputType="text"
                      title="Source type"
                      name="source"
                      classStar="text-red-500"
                      controlFunc={handleInputChange}
                      controlFuncBlur={handleBlur}
                      content={formFields.source}
                      disabled={false}
                      errorMessage={formFieldsError.sourceError}
                      isRequired={true}
                    />

                    <TextArea
                      title="Description"
                      rows={5}
                      name="description"
                      content={formFields.description}
                      resize={false}
                      placeholder="Enter description"
                      controlFunc={(e) =>
                        setFormFields((prev) => ({
                          ...prev,
                          description: e.target.value,
                        }))
                      }
                      controlFuncBlur={() => {}}
                      disabled={false}
                      tabIndex="0"
                      errorMessage={formFieldsError.descriptionError}
                    />

                    <div className="flex justify-center mt-6">
                      <Buttons
                        addScreenTitle={addScreenTitle}
                        updateScreenTitle={updateScreenTitle}
                        disabledBtn={false}
                        viewSaveButton={false}
                        handleSubmit={handleSubmit}
                        cancel={cancel}
                      />
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
  {isOpen && <ErrorPopup closeModal={() => setIsOpen(false)} />}
      <MainPopup
        popUpOpen={popUpOpen}
        setpopUpOpen={setpopUpOpen}
        Open={handleSourceType}
      >
        <div>
          <PopUpScreenTitle
            title="Source Type"
            setpopUpOpen={setpopUpOpen}
            viewDetails={viewDetails}
            deleteDetails={deleteDetails}
            blockDetails={blockDetails}
            unBlockDetails={unBlockDetails}
          />
          <SourceTypePopup data={popUpData} data1={popUpDataDD} />
        </div>

        <PopUpButtons
          deleteDetails={deleteDetails}
          blockDetails={blockDetails}
          unBlockDetails={unBlockDetails}
          rowIndex={rowIndex}
          handleSubmit={handleSubmit}
          cancel={cancel}
          disabledBtn={submitBtnDisabled ? true : false}
        />
      </MainPopup>
    </MainLayout>
  );
};

export default SourceType;